const schedule =
  window.setTimeout ||
  window.requestAnimationFrame ||
  window.requestIdleCallback;

export function nextTick(callback: () => void) {
  return new Promise<void>(resolve => {
    schedule(() => {
      callback();
      resolve();
    });
  });
}
